export default "__VITE_ASSET__Cpsw485y__"